<template>
  <v-container>
  <div class="link1">
      <router-link to="/contact">CONTACT</router-link>
  </div>
    <v-row class="text-center">

      <v-col class="my-15">
        <h1 class="font-weight-bold mb-3">
          HAJIME<br><span>SHOJI</span>
        </h1>

      </v-col>

      <v-col
        class="mb-5"
        cols="12"
      >
        <h2 class="font-weight-bold mb-10">
          WORKS
        </h2>

        <v-row class="d-flex flex-row align-start mx-0 ">
          <v-flex xs12 sm6 md3>
        <v-img
          :src="require('../assets/sc.jpg')"
          class="flex-grow-0 flex-shrink-0"
          contain
          cols="2"
          width="100%"
          @click.stop="dialog = true"
        />
</v-flex>
          <v-flex xs12 sm6 md3>
        <v-img
          :src="require('../assets/jungleocean.jpg')"
          class="flex-grow-0 flex-shrink-0"
          contain
          cols="2"
          width="100%"
          @click.stop="dialog2 = true"
        />
</v-flex>
          <v-flex xs12 sm6 md3>
        <v-img
          :src="require('../assets/crystalheart_i.jpg')"
          class="flex-grow-0 flex-shrink-0"
          contain
          cols="2"
          width="100%"
          @click.stop="dialog3 = true"
        />
</v-flex>
          <v-flex xs12 sm6 md3>
        <v-img
          :src="require('../assets/crystalheart.jpg')"
          class="flex-grow-0 flex-shrink-0"
          contain
          cols="2"
          width="100%"
          @click.stop="dialog4 = true"
        />
</v-flex>
          <v-flex xs12 sm6 md3>
        <v-img
          :src="require('../assets/crystalheart_lp.jpg')"
          class="flex-grow-0 flex-shrink-0"
          contain
          cols="2"
          width="100%"
          @click.stop="dialog5 = true"
        />
</v-flex>
          <v-flex xs12 sm6 md3>
        <v-img
          :src="require('../assets/columbia.jpg')"
          class="flex-grow-0 flex-shrink-0"
          contain
          cols="2"
          width="100%"
          @click.stop="dialog6 = true"
        />
</v-flex>
          <v-flex xs12 sm6 md3>
        <v-img
          :src="require('../assets/yokohamaplan.jpg')"
          class="flex-grow-0 flex-shrink-0"
          contain
          cols="2"
          width="100%"
          @click.stop="dialog7 = true"
        />
</v-flex>
          <v-flex xs12 sm6 md3>
        <v-img
          :src="require('../assets/sekigahara_photocon.jpg')"
          class="flex-grow-0 flex-shrink-0"
          contain
          cols="2"
          width="100%"
          @click.stop="dialog8 = true"
        />
</v-flex>
          <v-flex xs12 sm6 md3>
        <v-img
          :src="require('../assets/s-afrika.jpg')"
          class="flex-grow-0 flex-shrink-0"
          contain
          cols="2"
          width="100%"
          @click.stop="dialog9 = true"
        />
</v-flex>
          <v-flex xs12 sm6 md3>
        <v-img
          :src="require('../assets/toroku.jpg')"
          class="flex-grow-0 flex-shrink-0"
          contain
          cols="2"
          width="100%"
          @click.stop="dialog10 = true"
        />
</v-flex>
          <v-flex xs12 sm6 md3>
        <v-img
          :src="require('../assets/webguide.jpg')"
          class="flex-grow-0 flex-shrink-0"
          contain
          cols="2"
          width="100%"
          @click.stop="dialog11 = true"
        />
</v-flex>
          <v-flex xs12 sm6 md3>
        <v-img
          :src="require('../assets/inspection.jpg')"
          class="flex-grow-0 flex-shrink-0"
          contain
          cols="2"
          width="100%"
          @click.stop="dialog12 = true"
        />
</v-flex>
          <v-flex xs12 sm6 md3>
        <v-img
          :src="require('../assets/delta.jpg')"
          class="flex-grow-0 flex-shrink-0"
          contain
          cols="2"
          width="100%"
          @click.stop="dialog13 = true"
        />
</v-flex>
          <v-flex xs12 sm6 md3>
        <v-img
          :src="require('../assets/portfolio_bootstrap.jpg')"
          class="flex-grow-0 flex-shrink-0"
          contain
          cols="2"
          width="100%"
          @click.stop="dialog14 = true"
        />
</v-flex>

        </v-row>
      </v-col>

    </v-row>

<div class="link2 my-15">
      <router-link to="/contact">CONTACT</router-link>
</div>

        <p class="footercopy font-weight-regular">
          Copyright (C) Hajime Shoji All Rights Reserved.
        </p>
<!-- モーダル1 -->
    <v-dialog
      v-model="dialog"
    >
      <v-card>

        <v-card-actions>
          <v-btn
            color="darken-1"
            text
            @click="dialog = false"
          >
            ×
          </v-btn>
        </v-card-actions>

        <v-card-title class="headline">Super continental &amp; nude.</v-card-title>

        <v-card-text>
          <p>Design / coding</p>
          <p>既存のPCページを元に、スマホページを作成させていただきました。</p>
        </v-card-text>

               <img src="../assets/sc_m.jpg" alt="">

               <div class="viewWebsite">
                  <a href="http://www.sc-n.jp/">view website</a>
                </div>

      </v-card>
    </v-dialog>
<!-- モーダル1 -->

<!-- モーダル2 -->
    <v-dialog
      v-model="dialog2"
    >
      <v-card>

        <v-card-actions>
          <v-btn
            color="darken-1"
            text
            @click="dialog2 = false"
          >
            ×
          </v-btn>
        </v-card-actions>

        <v-card-title class="headline">ジャングルオーシャン</v-card-title>

        <v-card-text>
          <p>Design / coding / Writing</p>
          <p>運営に携わらせていただいています。</p>
        </v-card-text>

               <img src="../assets/jungleocean_m.jpg" alt="">

               <div class="viewWebsite">
                  <a href="https://www.jungleocean.com/">view website</a>
                </div>

      </v-card>
    </v-dialog>
<!-- モーダル2 -->

<!-- モーダル3 -->
    <v-dialog
      v-model="dialog3"
    >
      <v-card>

        <v-card-actions>
          <v-btn
            color="darken-1"
            text
            @click="dialog3 = false"
          >
            ×
          </v-btn>
        </v-card-actions>

        <v-card-title class="headline">クリスタルハート 海外旅行トップページ</v-card-title>

        <v-card-text>
          <p>Design / coding</p>
          <p>リニューアルに伴い、クリスタルハートの各ページのデザインとコーディングを担当させていただきました。</p>
        </v-card-text>

               <img src="../assets/crystalheart_i_m.jpg" alt="">

               <div class="viewWebsite">
                  <a href="http://www.hankyu-travel.com/crystal/kaigai/">view website</a>
                </div>

      </v-card>
    </v-dialog>
<!-- モーダル3 -->

<!-- モーダル4 -->
    <v-dialog
      v-model="dialog4"
    >
      <v-card>

        <v-card-actions>
          <v-btn
            color="darken-1"
            text
            @click="dialog4 = false"
          >
            ×
          </v-btn>
        </v-card-actions>

        <v-card-title class="headline">クリスタルハート トップページ</v-card-title>

        <v-card-text>
          <p>Design / coding</p>
          <p>リニューアルに伴い、クリスタルハートの各ページのデザインとコーディングを担当させていただきました。</p>
        </v-card-text>

               <img src="../assets/crystalheart_m.jpg" alt="">

               <div class="viewWebsite">
                  <a href="http://www.hankyu-travel.com/crystal/">view website</a>
                </div>

      </v-card>
    </v-dialog>
<!-- モーダル4 -->

<!-- モーダル5 -->
    <v-dialog
      v-model="dialog5"
    >
      <v-card>

        <v-card-actions>
          <v-btn
            color="darken-1"
            text
            @click="dialog5 = false"
          >
            ×
          </v-btn>
        </v-card-actions>

        <v-card-title class="headline">クリスタルハート LP</v-card-title>

        <v-card-text>
          <p>Design / coding</p>
          <p>デザインとコーディングを担当させていただきました。</p>
        </v-card-text>

               <img src="../assets/crystalheart_lp_m.jpg" alt="">

               <div class="viewWebsite">
                  <a href="http://www.hankyu-travel.com/crystal/kaigai/tyo/LP/LE102/">view website</a>
                </div>

      </v-card>
    </v-dialog>
<!-- モーダル5 -->

<!-- モーダル6 -->
    <v-dialog
      v-model="dialog6"
    >
      <v-card>

        <v-card-actions>
          <v-btn
            color="darken-1"
            text
            @click="dialog6 = false"
          >
            ×
          </v-btn>
        </v-card-actions>

        <v-card-title class="headline">色彩あふれる コロンビア旅行</v-card-title>

        <v-card-text>
          <p>Design / coding</p>
          <p>PCページを元にスマホページのデザインとコーディングを担当させていただきました。</p>
        </v-card-text>

               <img src="../assets/columbia_m.jpg" alt="">

               <div class="viewWebsite">
                  <a href="https://www.hankyu-travel.com/tokyo2/nanbei/ut756/">view website</a>
                </div>

      </v-card>
    </v-dialog>
<!-- モーダル6 -->

<!-- モーダル7 -->
    <v-dialog
      v-model="dialog7"
    >
      <v-card>

        <v-card-actions>
          <v-btn
            color="darken-1"
            text
            @click="dialog7 = false"
          >
            ×
          </v-btn>
        </v-card-actions>

        <v-card-title class="headline">時遊人〜現地集合・解散と日帰り列車の旅〜×あうたびに、発見 横浜プラン</v-card-title>

        <v-card-text>
          <p>Design / coding</p>
          <p>デザインとコーディングを担当させていただきました。</p>
        </v-card-text>

               <img src="../assets/yokohamaplan_m.jpg" alt="">

               <div class="viewWebsite">
                  <a href="https://www.hankyu-travel.com/tyo-d/jiyuhjin-yokohama/">view website</a>
                </div>

      </v-card>
    </v-dialog>
<!-- モーダル7 -->

<!-- モーダル8 -->
    <v-dialog
      v-model="dialog8"
    >
      <v-card>

        <v-card-actions>
          <v-btn
            color="darken-1"
            text
            @click="dialog8 = false"
          >
            ×
          </v-btn>
        </v-card-actions>

        <v-card-title class="headline">「日本の城」＆「戦国関ヶ原」フォトコンテスト結果発表</v-card-title>

        <v-card-text>
          <p>Design / coding</p>
          <p>デザインとコーディングを担当させていただきました。</p>
        </v-card-text>

               <img src="../assets/sekigahara_photocon_m.jpg" alt="">

               <div class="viewWebsite">
                  <a href="http://www.hankyu-travel.com/sns/cp/sekigahara/">view website</a>
                </div>

      </v-card>
    </v-dialog>
<!-- モーダル8 -->

<!-- モーダル9 -->
    <v-dialog
      v-model="dialog9"
    >
      <v-card>

        <v-card-actions>
          <v-btn
            color="darken-1"
            text
            @click="dialog9 = false"
          >
            ×
          </v-btn>
        </v-card-actions>

        <v-card-title class="headline">JALパック 南アフリカ満喫の旅</v-card-title>

        <v-card-text>
          <p>Design / coding</p>
          <p>デザインとコーディングを担当させていただきました。</p>
        </v-card-text>

               <img src="../assets/s-afrika_m.jpg" alt="">

               <div class="viewWebsite">
                  <a href="https://www.jal.co.jp/intltour/jmb/southafr/">view website</a>
                </div>

      </v-card>
    </v-dialog>
<!-- モーダル9 -->

<!-- モーダル10 -->
    <v-dialog
      v-model="dialog10"
    >
      <v-card>

        <v-card-actions>
          <v-btn
            color="darken-1"
            text
            @click="dialog10 = false"
          >
            ×
          </v-btn>
        </v-card-actions>

        <v-card-title class="headline">ウェブのお悩みガイド 各ページ</v-card-title>

        <v-card-text>
          <p>Design / coding</p>
          <p>リニューアルに伴いデザインとコーディングを担当させていただきました。</p>
        </v-card-text>

               <img src="../assets/toroku_m.jpg" alt="">

               <div class="viewWebsite">
                  <a href="http://www.hankyu-travel.com/help/toroku/step1.php">view website</a>
                </div>

      </v-card>
    </v-dialog>
<!-- モーダル10 -->

<!-- モーダル11 -->
    <v-dialog
      v-model="dialog11"
    >
      <v-card>

        <v-card-actions>
          <v-btn
            color="darken-1"
            text
            @click="dialog11 = false"
          >
            ×
          </v-btn>
        </v-card-actions>

        <v-card-title class="headline">ウェブのお悩みガイド トップページ</v-card-title>

        <v-card-text>
          <p>coding</p>
          <p>コーディングを担当させていただきました。</p>
        </v-card-text>

               <img src="../assets/webguide_m.jpg" alt="">

               <div class="viewWebsite">
                  <a href="http://www.hankyu-travel.com/help/webguide/">view website</a>
                </div>

      </v-card>
    </v-dialog>
<!-- モーダル11 -->

<!-- モーダル12 -->
    <v-dialog
      v-model="dialog12"
    >
      <v-card>

        <v-card-actions>
          <v-btn
            color="darken-1"
            text
            @click="dialog12 = false"
          >
            ×
          </v-btn>
        </v-card-actions>

        <v-card-title class="headline">視察レポート トップページ</v-card-title>

        <v-card-text>
          <p>Design / coding</p>
          <p>デザインとコーディングを担当させていただきました。</p>
        </v-card-text>

               <img src="../assets/inspection_m.jpg" alt="">

               <div class="viewWebsite">
                  <a href="http://www.hankyu-travel.com/tokyo2/inspection_report/">view website</a>
                </div>

      </v-card>
    </v-dialog>
<!-- モーダル12 -->

<!-- モーダル13 -->
    <v-dialog
      v-model="dialog13"
    >
      <v-card>

        <v-card-actions>
          <v-btn
            color="darken-1"
            text
            @click="dialog13 = false"
          >
            ×
          </v-btn>
        </v-card-actions>

        <v-card-title class="headline">e-very デルタ航空特集ページ</v-card-title>

        <v-card-text>
          <p>Design / coding</p>
          <p>デザインとコーディングを担当させていただきました。</p>
        </v-card-text>

               <img src="../assets/delta_m.jpg" alt="">

               <div class="viewWebsite">
                  <a href="https://www.hankyu-travel.com/e-very/tokyo/north-america/delta/">view website</a>
                </div>

      </v-card>
    </v-dialog>
<!-- モーダル13 -->

<!-- モーダル14 -->
    <v-dialog
      v-model="dialog14"
    >
      <v-card>

        <v-card-actions>
          <v-btn
            color="darken-1"
            text
            @click="dialog14 = false"
          >
            ×
          </v-btn>
        </v-card-actions>

        <v-card-title class="headline">ポートフォリオサイト</v-card-title>

        <v-card-text>
          <p>Design / coding</p>
          <p>ポートフォリオサイトのトップページ。Bootstrap4、jQueryを使用しています。</p>
        </v-card-text>

               <img src="../assets/portfolio_bootstrap_m.jpg" alt="">

               <div class="viewWebsite">
                  <a href="https://hajime-shoji.work/">view website</a>
                </div>

      </v-card>
    </v-dialog>
<!-- モーダル14 -->

<router-view/>
  </v-container>
</template>

<style>
  main{
    background-color: #FAFAFA;
  }
  main .container{
    padding-bottom:0;
  }
  h1{
    color: #41B883;
    text-shadow: 8px 0px 0px #35495D;
    font-size: 70px;
    letter-spacing: 1rem;
    text-align:center;
  }
  h1 span{
    letter-spacing: 1.9rem;
  }
  h2{
    background: #41B883;
    text-shadow: 6px 0px 0px #35495D;
    color: #fff;
    font-size: 50px;
    letter-spacing: 1rem;
    position: relative;
    border-radius: 5px;
  }
  h2:after {
    position: absolute;
    content: '';
    top: 100%;
    left: 48%;
    border: 15px solid transparent;
    border-top: 15px solid #41B883;
    width: 0;
    height: 0;
  }
  .link1{
    width:100%;
    text-align:right;
    font-size: 20px;
  }
  .link2{
    width:100%;
    text-align:center;
    font-size: 30px;
  }
  .link1 a, .link2 a{
    text-decoration: none;
    font-weight: bold;
    padding: 10px 30px;
  }
  .container .link1 a{
    color: #41B883;
    transition: .5s;
  }
  .container .link1 a:hover{
    opacity: 0.6;
  }
  .container .link2 a{
    background-color: #41B883;
    color: #fff;
    border-radius: 30px;
    transition: .5s;
  }
  .container .link2 a:hover{
    background-color: #fff;
    color: #41B883;
    border: 2px  solid #41B883;
  }
  .v-image{
    cursor: pointer;
  }
  .v-application p.footercopy{
    text-align:center;
    margin: 0;
  }
  .v-card{
    padding-bottom:30px;
  }
  .v-dialog{
    position: relative;
  }
  .v-dialog .v-btn__content{
    font-size:50px;
  }
  .v-dialog .v-btn{
    position: absolute;
    top: 0;
    right: 0;
    padding:0;
  }
  .v-dialog .v-btn:hover{
    background-color: #fff;
  }
  .v-dialog__content > .v-dialog > .v-card > .v-card__title{
    font-weight:bold;
    padding: 24px 24px 10px;
  }
  .v-dialog img{
    width: 100%;
  }
  .v-dialog .viewWebsite{
    text-align: center;
    margin:30px auto 0;
  }
  .v-dialog .viewWebsite a{
    text-decoration: none;
    border: 1px solid #41B883;
    color: #35495D;
    letter-spacing: .2rem;
    transition: .5s;
    font-size: 24px;
    padding: 10px 30px;
    border-radius: 30px;
  }
  .v-dialog .viewWebsite a:hover{
    border: 1px solid #35495D;
    color: #41B883;
    background-color: #35495D;
    letter-spacing: .2rem;
  }
  @media (max-width: 600px) {
    .v-image{
      padding-bottom: 40px;
    }
    .v-dialog{
      max-width: 290px;
    }
  }
  @media ( min-width:600px) and (max-width: 960px) {
    .v-dialog{
      max-width: 500px;
    }
  }
  @media ( min-width:960px) and (max-width: 1264px) {
    .v-dialog{
      max-width: 800px;
    }
  }
  @media ( min-width:1264px) and (max-width: 1904px) {
    .v-dialog{
      max-width: 1200px;
    }
  }
  @media (min-width: 1904px) {
    .v-dialog{
      max-width: 1500px;
    }
  }

</style>

<script>
export default {
  name: 'Home',
  components: {
  },
  data () {
    return {
      dialog: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      dialog6: false,
      dialog7: false,
      dialog8: false,
      dialog9: false,
      dialog10: false,
      dialog11: false,
      dialog12: false,
      dialog13: false,
      dialog14: false,
    }
  },
}
</script>